import script from "./base-select.vue?vue&type=script&setup=true&lang=ts"
export * from "./base-select.vue?vue&type=script&setup=true&lang=ts"

import "./base-select.vue?vue&type=style&index=0&id=60f93b41&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60f93b41"]])

export default __exports__